module.exports = __webpack_public_path__ + "static/media/state-back-14.c13a8749.jpg";